module.exports = __webpack_public_path__ + "img/arrow-left-white.0f6f4e66.svg";